import React from "react";
import classNames from "classnames";
import _ from "lodash";
const PASSWORD_TYPE = "password";
export default class BigInput extends React.Component {
  state = { value: this.props.value || "", error: "" };

  hasError = () => {
    return this.state.error;
  };

  componentWillMount = () => {
    this.setState({ type: this.props.type });
  };

  componentWillReceiveProps = newProps => {
    let newState = _.assign({}, this.state, newProps);
    this.setState(newState);
  };

  handleChange = e => {
    this.props.handleChange({ [this.props.name]: e.target.value });
  };

  isPasswordType = () => {
    return this.props.type === PASSWORD_TYPE;
  };

  handleChangeType = e => {
    if (this.state.type === PASSWORD_TYPE) this.setState({ type: "text" });
    else this.setState({ type: PASSWORD_TYPE });
  };

  isArray = () => {
    if (this.state.error) return Array.isArray(this.state.error.slice());
    else return false;
  };

  render() {
    const props = this.props.maxLength ? {maxLength: this.props.maxLength} : {};
    return (
      <div
        className={classNames({
          "input-holder": true,
          animate: true,
          "has-error": this.hasError(),
          "main-title": true,
          touched: this.state.value != ""
        })}
      >
        <input
          {...props}
          id={`${this.props.name}${this.props.index}`}
          className="animate-input"
          type={this.state.type}
          value={this.state.value}
          onChange={this.handleChange}
        />
        <label
          className="animate-label"
          style={{ pointerEvents: "none" }}
          htmlFor={`${this.props.name}${this.props.index}`}
        >
          {this.props.placeholder}
        </label>
        <span className="bar" />
        {this.isPasswordType() && (
          <i
            onClick={this.handleChangeType}
            className={classNames({
              icon: true,
              "ic-eye-icon": true,
              active: this.state.type != PASSWORD_TYPE
            })}
          />
        )}
        <span className="error-text">
          {this.isArray() ? this.state.error.join(", ") : null}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/BigInput.jsx